import clsx from 'clsx';
import React from 'react';
import { Switch, FormControlLabel } from '@material-ui/core';
import { getKeyboardKey } from '../wcag/getKeyboardKey';
import { AriaRoleModel } from '../wcag/tools/wcag.model';

import useStyles from './Switch.style';
export interface CustomSwitchProps {
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  name?: string;
  checked?: boolean;
  disabled?: boolean;
  role?: AriaRoleModel;
  tabIndex?: number;
  label?: string;
  labelPlacement?: 'start' | 'end';
  inputProps?: {
    id?: string;
    'aria-checked'?: boolean;
    'aria-label'?: string;
    'aria-labelledby'?: string;
    role?: AriaRoleModel;
    tabIndex?: number;
    'data-testid'?: string;
  };
}

const CustomSwitch: React.FC<CustomSwitchProps> = ({
  onChange = () => null,
  name,
  checked,
  disabled,
  className,
  role = 'switch',
  tabIndex,
  label,
  labelPlacement = 'start',
  inputProps
}) => {
  const c = useStyles({ labelPlacement });

  const handleKeyDown = (event: React.KeyboardEvent) => {
    const { isSpaceKey } = getKeyboardKey(event.nativeEvent);

    if (isSpaceKey && !disabled) {
      onChange({ target: { checked: !checked } } as React.ChangeEvent<HTMLInputElement>);
    }
  };

  const switchElement = (
    <Switch
      classes={{
        root: c.root,
        thumb: c.thumb,
        switchBase: c.switchBase,
        checked: c.checked,
        track: c.track,
        disabled: c.disabled
      }}
      inputProps={{
        id: name,
        'aria-checked': checked,
        role,
        tabIndex,
        onKeyDown: handleKeyDown,
        ...inputProps
      }}
      name={name}
      checked={checked}
      disabled={disabled}
      onChange={onChange}
      className={!label ? className : undefined}
    />
  );

  if (label) {
    return (
      <FormControlLabel
        control={switchElement}
        label={label}
        disabled={disabled}
        className={clsx(c.formControlLabel, className)}
        labelPlacement={labelPlacement}
      />
    );
  }

  return switchElement;
};

export { CustomSwitch as Switch };
